(function() {
  'use strict';

  angular
    .module('admin.users.details.reports', [])
    .controller('ReportsAdminCtrl', ReportsAdminCtrl);

  /** @ngInject */
  function ReportsAdminCtrl($scope, $stateParams, UsersService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;

    vm.sortType = '';
    vm.sortReverse = false;

    load();

    function load() {
      UsersService.listReports($stateParams.parentId, vm.sortType).then(success);

      function success(result){
        for (var i = 0; i < result.results.length; i++) {
          result.results[i]['ts-m'] = new Date(parseInt(result.results[i]['ts-m'].toString().substring(0, result.results[i]['ts-m'].toString().length - 3)));
        }
        vm.items = result.results;
      }
    }

    vm.sort = function(type){
      vm.sortReverse = !vm.sortReverse;
      if (vm.sortReverse) {
        vm.sortType = type + '-asc';
      } else {
        vm.sortType = type + '-desc';
      }
      load();
    };

  }

})();
